var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boutique"},[_c('h1',{staticClass:"boutique-title"},[_vm._v("热门好课")]),_c('ul',{staticClass:"boutique-main"},_vm._l((_vm.popularCourses),function(item,index){return _c('li',{key:index},[_c('course-item',{attrs:{"course":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }